/* @flow */
import React from 'react';

import {
  PaymentAccountAdditionalVerificationNotification,
  PaymentAccountVerificationNotification,
  PendingBankAccountRequestNotification,
  AddBankAccountNotification,
} from 'payments/components/ActivitiesNotification.jsx';

import './styles/ActivitiesNotifications.scss';

type Props = {
  needToAddBankAccount: boolean,
  needAccountVerification: boolean,
  needAdditionalVerification: boolean,
  pendingBankAccountRequestsNumber: number,
  refreshPaymentAccount: () => void,
}

class ActivitiesNotifications extends React.Component {
  props: Props;

  render() {
    const shouldRender = (
      this.props.needAccountVerification ||
      this.props.needToAddBankAccount ||
      this.props.needAdditionalVerification ||
      this.props.pendingBankAccountRequestsNumber > 0
    );

    if (!shouldRender) {
      return null;
    }

    return (
      <div className="ActivitiesNotifications">
        {this.props.needAccountVerification &&
          <div className="ActivitiesNotifications-item">
            <PaymentAccountVerificationNotification />
          </div>
        }

        {this.props.needAdditionalVerification &&
          <div className="ActivitiesNotifications-item">
            <PaymentAccountAdditionalVerificationNotification />
          </div>
        }

        {this.props.needToAddBankAccount &&
          <div className="ActivitiesNotifications-item">
            <AddBankAccountNotification onBankAccountAdded={this.props.refreshPaymentAccount} />
          </div>
        }

        {this.props.pendingBankAccountRequestsNumber > 0 &&
          <div className="ActivitiesNotifications-item">
            <PendingBankAccountRequestNotification number={this.props.pendingBankAccountRequestsNumber} />
          </div>
        }
      </div>
    );
  }
}

export default ActivitiesNotifications;



// WEBPACK FOOTER //
// ./src/payments/components/ActivitiesNotifications.jsx